import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html, body, #app {
    height: 100%;
  }

  #app {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  body {
    background-color: #051221;
    -webkit-font-smoothing: antialiased !important;
  }

  body, input, button {
    color: #fff;
    font-size: 14px;
    font-family: "Roboto", Arial, Helvetica, sans-serif;
  }

  button {
    cursor: pointer;
  }

  ul {
    list-style: none;
  }
`;
